import Empty from 'constants/empty';

const REWARDS_PREVIEW_LIMIT = 6;

const getRewardDate = group => new Date(group?.transactionDate || 0).getTime();

const getRewardSku = item => item?.sku || item;

const getSkuImage = sku => sku?.skuImages?.image62 || sku?.skuImages?.image97 || sku?.skuImages?.image135 || sku?.primaryImage || sku?.imageUrl;

const getRewardAltText = sku => [sku?.brandName, sku?.productName].filter(Boolean).join(' ') || sku?.skuName || 'Redeemed reward';

/**
 * Maps purchase-history reward groups into the Rewards Redeemed preview thumbnails.
 *
 * @param {Array} groups Purchase-history groups containing transactionDate and purchasedItems entries.
 * @param {number} limit Maximum number of reward thumbnails to return.
 * @returns {Array<{key: string, imageUrl: string, altText: string, productId: string, skuId: string}>} Recent reward thumbnails.
 */
const mapHistoryRewardsRedeemed = (groups = Empty.Array, limit = REWARDS_PREVIEW_LIMIT) => {
    if (!Array.isArray(groups)) {
        return [];
    }

    const rewards = [];
    const sortedGroups = [...groups].sort((left, right) => getRewardDate(right) - getRewardDate(left));

    for (const group of sortedGroups) {
        if (rewards.length >= limit) {
            break;
        }

        const items = Array.isArray(group?.purchasedItems) ? group.purchasedItems : [];

        for (const item of items) {
            if (rewards.length >= limit) {
                break;
            }

            const sku = getRewardSku(item);
            const imageUrl = getSkuImage(sku);

            if (imageUrl) {
                rewards.push({
                    key: [group?.transactionDate || 'reward', sku?.skuId || sku?.productId || imageUrl, rewards.length].join('-'),
                    imageUrl,
                    altText: getRewardAltText(sku),
                    productId: sku?.productId,
                    skuId: sku?.skuId
                });
            }
        }
    }

    return rewards;
};

export default mapHistoryRewardsRedeemed;
